var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found"},[_c('img',{attrs:{"src":require("@/assets/img/404.svg")}}),_c('br'),_c('el-button',{attrs:{"type":"primary","plain":""},on:{"click":function($event){return _vm.$router.push('/')}}},[_vm._v(_vm._s(_vm.$t('return')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }